import axios from "axios"
import { config } from "process";

export const backendUrl = process.env.NEXT_PUBLIC_API_URL

/**
 * Public file URL: NEXT_PUBLIC_API_URL + path (same as axios baseURL).
 * If API URL missing at build time, falls back to NEXT_PUBLIC_URL + /backend.
 */
export function staticFileUrl(path: string | null | undefined): string {
  if (path == null) return "";
  const p = String(path).trim();
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  const rel = p.startsWith("/") ? p : `/${p}`;
  const encodedPath = encodeURI(rel);
  const apiBase = (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/$/, "");
  if (apiBase) return `${apiBase}${encodedPath}`;
  const site = (process.env.NEXT_PUBLIC_URL || "").replace(/\/$/, "");
  if (site) return `${site}/backend${encodedPath}`;
  return encodedPath;
}

const $api = axios.create({
  withCredentials: true, 
  headers: {
    "Content-Type": "application/json",
  }, 
  baseURL: process.env.NEXT_PUBLIC_API_URL,
})
function getCookie(cname: string) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$api.interceptors.request.use((config) => {
  const locale = getCookie("NEXT_LOCALE")
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  config.headers['CustomerAuthentication-Token'] = `Bearer ${localStorage.getItem("token")}`;
  config.headers['ngrok-skip-browser-warning'] = `true`;
  config.headers["lang"] = locale
  
  return config
})

export const request = async (options) => {

  const onSuccess = (response) => {
    return response?.data;
  };

  const onError = (error) => {
    return Promise.reject(error.response.data);
  };

  return $api(options).then(onSuccess).catch(onError);
};




$api.interceptors.response.use(


)


export default $api